import {ProductDetailsSection_ArticleDetail_MaterialLane_CareIcon} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/product_details.types';
import {Image, SimpleList, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {SectionWrapper} from './SectionWrapper';

const CARE_ICON_WIDTH = [25, 50];
const CARE_ICON_BREAKPOINTS = [{columns: 12}];

export const MaterialSection: FC<{
  label: string;
  bulletPoints: string[];
  careIcons: ProductDetailsSection_ArticleDetail_MaterialLane_CareIcon[];
}> = ({label, bulletPoints, careIcons}) => {
  return (
    <SectionWrapper dataTestId={`productDetailsMaterialSection_${label}`}>
      <StyledDescriptionDetails>
        <SimpleList>{bulletPoints}</SimpleList>
        {careIcons.length > 0 && (
          <CareIcons data-testid="productDetailsCareIcons">
            {careIcons.map((icon, index) => (
              <CareIconWrapper key={icon.icon?.url ?? index}>
                {icon.icon && (
                  <StyledCareIcon
                    data-testid={`productDetailsCareIconـ${icon.label}`}
                    src={icon.icon?.url}
                    role="presentation"
                    widths={CARE_ICON_WIDTH}
                    breakpoints={CARE_ICON_BREAKPOINTS}
                    importance="low"
                    loading="lazy"
                    ratio="1:1"
                    width="20"
                    height="20"
                  />
                )}
                <Text
                  data-testid={`productDetailsCareIconLabel`}
                  size="px14"
                  color="inherit"
                >
                  {icon.label}
                </Text>
              </CareIconWrapper>
            ))}
          </CareIcons>
        )}
      </StyledDescriptionDetails>
    </SectionWrapper>
  );
};

const StyledDescriptionDetails = styled.dd`
  margin-inline-start: 0;
`;

const StyledCareIcon = styled(Image)`
  margin-right: 0.5rem;
`;

const CareIcons = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 0;
  hyphens: auto;
  gap: 8px;
`;

const CareIconWrapper = styled.li`
  display: flex;
  align-items: center;
`;
